import React from "react";
import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectComparatorsByChapter } from "modules/customer/tools/location/locationSlice";
import { selectIsLoading, selectHasErrors, selectStoreCounts } from "modules/customer/tools/location/retailers/retailersSlice";


import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

import numberFormatter from "utils/numberFormatter";

const IndependentsPercentage = () => {
    const colourPalette = useColourPalette();
    const selectedComparator = useAppSelector(selectComparatorsByChapter)?.retailers;
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const independenceRate = useAppSelector(selectStoreCounts).independenceRate;
    const selectedStoreNumberOfStores = independenceRate?.pinnedLocationValue ?? 0;
    const comparatorNumberOfStores = independenceRate?.comparisonValue ?? 0;
    const difference = independenceRate?.difference ?? 0;
    const differencePositiveSign = difference > 0 ? "+" : "";

    const label = `Independent stores`;

    return (
        <Box width="100%" height="100%" data-cy="independent-percentage-in-retail-zone">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {numberFormatter.toPercentage(selectedStoreNumberOfStores, true, 1)}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {numberFormatter.toPercentage(comparatorNumberOfStores, true, 1)}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${selectedComparator?.storeName} `}
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {differencePositiveSign}{numberFormatter.toPercentage(difference, true, 1)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default IndependentsPercentage;
